import { useEffect, useState } from 'react';
import { useFarms } from './useFarms';
import { useFields } from './useFields';

export const useFarmsAndFields = (orgId: string) => {
  const { farms, loading: farmsLoading, error: farmsError } = useFarms(orgId);
  const [selectedFarm, setSelectedFarm] = useState<any>(null);
  const {
    fields,
    loading: fieldsLoading,
    error: fieldsError,
  } = useFields(selectedFarm?.root_region_id || '');

  useEffect(() => {
    if (farms.length > 0 && !selectedFarm) {
      setSelectedFarm(farms[0]);
    }
  }, [farms, selectedFarm]);

  return {
    farms,
    fields,
    selectedFarm,
    setSelectedFarm,
    loading: farmsLoading || fieldsLoading,
    error: farmsError || fieldsError,
  };
};
